const getProductBadge = (type, product) => {
  let result;

  if (type === 'auction') {
    result = `BID: $${product.currentBidValue}`;
  } else {
    result = `$${product.price}`;
  }

  return result;
};

const getProductInfo = (type, product) => {
  let result;

  switch (type) {
    case 'auction':
     // result = `Min:$${product.minBidValue}`;
     result = product.silent ? `Silent` : ``;
      break;

    case 'raffle':
      result = product.silent ? `Anonymous` : ``;;
      break;

    case 'deals':
    default:
      result = `# Avail: ${product.limitQuantity}`;
  }

  return result;

};

const getProductImage = (type, product) => {
  let result;

  switch (type) {
    case 'auction':
      result = product.bidImage;
      break;

    case 'raffle':
      result = product.raffleImage;
      break;

    case 'deals':
    default:
      result = product.dealImage;
  }

  return result;
};

const getValidStr = (string) =>{

    return `${string}`.length === 1 ? `0${string}` : string;
  };

const getTimeBought = (purchaseData) => {

    let result = purchaseData;
    let hours = `${purchaseData}`.substring(11,13);
    let mins = `${purchaseData}`.substring(14,16);

    let hoursInt = parseInt(hours);
    let amPM = hoursInt > 12 ? ' PM' : ' AM'
    let hourTime = hoursInt > 12 ? getValidStr(Math.round(hoursInt - 12)) : getValidStr(Math.round(hoursInt))
    hourTime = hourTime == '00' ? '12' : hourTime
    

    return 'Purchased: ' + hourTime + ':' + mins + amPM + ' on ' + getDateBought(purchaseData);

  }

const getTimeBid = (purchaseData) => {

    let result = purchaseData;
    let hours = `${purchaseData}`.substring(11,13);
    let mins = `${purchaseData}`.substring(14,16);

    let hoursInt = parseInt(hours);
    let amPM = hoursInt > 12 ? ' PM' : ' AM'
    let hourTime = hoursInt > 12 ? getValidStr(Math.round(hoursInt - 12)) : getValidStr(Math.round(hoursInt))
    hourTime = hourTime == '00' ? '12' : hourTime
    

    return 'Bid Placed: ' + hourTime + ':' + mins + amPM + ' on ' + getDateBought(purchaseData) ;

  }

const getDateBought = (purchaseData) => {


    return `${purchaseData}`.substring(0,10);

  }


export default {
  getProductBadge,
  getProductImage,
  getProductInfo,
  getTimeBought,
  getTimeBid,
  getDateBought
}